import { render, staticRenderFns } from "./solutionYzNeed.vue?vue&type=template&id=093ff8e0&scoped=true"
import script from "./solutionYzNeed.vue?vue&type=script&lang=js"
export * from "./solutionYzNeed.vue?vue&type=script&lang=js"
import style0 from "./solutionYzNeed.vue?vue&type=style&index=0&id=093ff8e0&prod&lang=css"
import style1 from "./solutionYzNeed.vue?vue&type=style&index=1&id=093ff8e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093ff8e0",
  null
  
)

export default component.exports